module.exports = __webpack_public_path__ + "img/9788952708540.ad16433a.jpg";